import { Link } from "react-router-dom";
import { Container } from "@/platform/layout/container";

const groups = [
  {
    title: "PsiEinstein",
    links: [
      { to: "/einstein", label: "Sobre o produto" },
      { to: "/metodo", label: "Método" },
      { to: "/diagnostico", label: "Diagnóstico" },
      { to: "/simulador", label: "Simulador" },
      { to: "/redacao", label: "Redação Vunesp" },
    ],
  },
  {
    title: "FuvestPro USP",
    links: [
      { to: "/usp", label: "Sobre o produto" },
      { to: "/usp", label: "Lista de espera" },
    ],
  },
  {
    title: "Plataforma",
    links: [
      { to: "/sobre", label: "Sobre" },
      { to: "/precos", label: "Planos" },
      { to: "/terms", label: "Termos de uso" },
      { to: "/privacy", label: "Privacidade" },
      { to: "/contato", label: "Contato" },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-[--color-border] bg-[color:var(--color-background)] py-16 text-[length:var(--text-body-sm)]">
      <Container>
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 font-display font-semibold">
              <span
                aria-hidden
                className="grid size-7 place-items-center rounded-sm bg-[color:var(--color-foreground)] text-[color:var(--color-background)] text-[10px] font-bold"
              >
                NS
              </span>
              Neuronix Study
            </Link>
            <p className="mt-3 max-w-xs text-[color:var(--color-muted-foreground)] text-pretty">
              Plataforma de alto desempenho para os vestibulares mais seletivos do Brasil.
              Engenharia reversa de banca, taxonomia detalhada e treino calibrado.
            </p>
          </div>
          {groups.map((g) => (
            <nav key={g.title} aria-label={g.title}>
              <p className="text-[length:var(--text-overline)] uppercase tracking-[var(--text-overline--letter-spacing)] text-[color:var(--color-muted-foreground)]">
                {g.title}
              </p>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={`${g.title}-${l.label}`}>
                    <Link
                      to={l.to}
                      className="text-[color:var(--color-foreground)] hover:text-[color:var(--color-accent)]"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 border-t border-[--color-border] pt-8 text-center text-[color:var(--color-muted-foreground)]">
          <p>© {new Date().getFullYear()} Neuronix Study · DMZ Digital. Todos os direitos reservados.</p>
        </div>
      </Container>
    </footer>
  );
}
